import { Stock } from '@models/stock';
import { Image } from '@models/image';

export class Categ{
  ident: string;
  name: string;
  filters: string[]=[];
}

export class SCateg{
  ident: string;
  name: string;
  filters: string[]=[];
}

export class Gamme{
  ident: string;
  name: string;
  filters: string[]=[];
}

export class Marque{
  ident: string;
  name: string;
  filters: string[]=[];
}

export class Tag{
  ident: string;
  name: string;
  filters: string[]=[];
}

export class Banner{
  ident?: string;
  name: string;
  color: string='#ffffff';
  start?: string;
  end?: string;
  filters?: string[]=[];
}

export class Filter{
  ident: string;
  name: string;
}

export class Rating{
  ident?: string;
  customer?: string;
  product?: string;
  date?: string;
  rate?: number;
  review?: string;
  state?: 'review' | 'actif' | 'supprimé'='review';
}

export class Price {
  ident: string;
  product: string;
  qte: number=1;
  isRemise: boolean;
  group: string=null;
  prix: number=0;
  discounted: number=null;
  start: string;
  end: string;
  img: string;
  priceImageFile: File;
  rmImage: boolean=false;
}

export class Alert{
  ident: string;
  product: string;
  email: string;
  target?: string='back-in-stock';
}

export class Product{
  //img: string;
  //subtitle: string;
  ident: string;
  name: string;
  ref: string;
  categ: string=null;
  scateg: string=null;
  gamme: string=null;
  marque: string=null;
  illustrator: string=null;
  author: string=null;
  isNew: boolean=false;
  isPromo: boolean=false;
  isUsed: boolean=false;
  statutStart: string=null;
  statutEnd: string=null;
  barrecode: string;
  prixAchat: number;
  tva: number;
  weight: number;
  length: number=null;
  height: number=null;
  depth: number=null;
  details: string;
  subtitle: string;
  video?: string;
  players: number;
  playersMax: number;
  duration?: number;
  age: number;
  lowStock: number;
  preorderStock: number;
  isDraft: boolean=false;
  isRupture: boolean=false;
  dispoFrns: number;
  releaseDate: string=null;
  limitOrder: number;
  duplicateImage: string;
  state: 'actif' | 'draft' | 'rupture' | 'supprimé'='draft';
  stars: number;
  images: Image[]=[];
  mainImage: Image = null;
  cover?: string;
  tags: Tag[]=[];
  ratings: Rating[]=[];
  prices: Price[]=[];
  banners: Banner[]=[];
  stocks: Stock[]=[];
  linked?: Product[];
  imageFiles: File[]=[];
  mainImageFile: File[]=[];
  rmImages: string[]=[];
  dateEnd?: string=null;

  canOrder(){
    let stocks: number=this.stocks.reduce((acc, curent) => acc+curent.qte, 0);
    let releaseDate: Date=new Date(this.releaseDate);
    let isPreordered: boolean = this.banners.find((b: { name: string; }) => b.name == 'Précommande')? true : false;
    // A product with no stock must always be in rupture
    return (this.state!='rupture' && stocks>0);
  }
}

export class ProductSelected{
  news: Product[];
  promos: Product[];
  used: Product[];
  goldnGob: Product[];
  crush: Product[];
  preorder: Product[];
}

export class ProductGoldnGob{
  products: Product[];
}
